// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2BUXz","imageUploader":"EGiftCard_imageUploader__1alSW"};